export default {
    InternalRefundOnly: {
        Doc: 'Refund Order No. / Sales Order No.',
        DocType: 'Refund order type',
        Source: 'Refund order source',
        nickname: 'Buyer nickname',
        Three: 'Third-party refund time',
        Add: 'New refund-only order',
        form: {
            NoteNo: 'Internal refund Order No.',
            refundorder: 'Third-party refund Order No.',
            partyorder: 'Customer Order No.',
            Internalorder: 'CSG Order No.',
            Refundtype: 'Refund order type',
            type: 'Refund type',

            Note: 'Refund order source',
            reason: 'Refund reason',
            Buyer: 'Buyer comments',
            Customer: 'Customer service comments',
            quantity: 'Refund quantity',
            Total: 'Total refund amount',
            method: 'Settlement method',
            nickname: 'Buyer nickname',
            Sales: 'Store',
            channel: 'Sales Channel',
            Three: 'Third-party refund time',
            Internal: 'Internal Creation Time',
            Refund: 'Refund completion time',
        },
    }
};
